import {Box, Drawer, IconButton, Typography} from '@mui/material'
import React, {useEffect, useState} from 'react'
import AppointmentDetails from '../../pages/crm/appointment/appointment-details/appointmentDetails'
import {useDispatch} from 'react-redux'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import EventOutlinedIcon from '@mui/icons-material/EventOutlined';
import {scrollCSS} from '../../App';
import {getAppointmentDetails} from '../../store/crm/appointment';
import Waveloading from '../../pages/loading/Waveloading';

const BURGUNDY = '#A72C68';
const PINK_BG = '#FAEFF5';
const PINK_BORDER = '#F0CDDB';

const AppointmentDetailsmodal = ({booking_id, onBookingClick}) => {
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [details, setDetails] = useState(null);
    const dispatch = useDispatch();
    const useCallback = typeof onBookingClick === 'function';

    const fetchDetails = async () => {
        if (!booking_id) return;
        setLoading(true);
        try {
            const {payload} = await dispatch(getAppointmentDetails(booking_id));
            if (payload && !Array.isArray(payload)) {
                setDetails(payload);
            } else {
                setDetails(null);
            }
        } finally {
            setLoading(false);
        }
    };

    const handleClick = () => {
        if (useCallback) {
            onBookingClick(booking_id);
            return;
        }
        setOpen(true);
        fetchDetails();
    };

    const handleClose = () => setOpen(false);

    useEffect(() => {
        if (!useCallback && open && booking_id && !details) {
            fetchDetails();
        }
    }, [booking_id, open]);

    const trigger = (
        <Box
            component="span"
            onClick={handleClick}
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 0.5,
                px: 1,
                py: 0.4,
                borderRadius: '6px',
                background: PINK_BG,
                color: BURGUNDY,
                fontSize: '12px',
                fontWeight: 700,
                border: `1px solid ${PINK_BORDER}`,
                cursor: 'pointer',
                transition: 'all 0.15s',
                '&:hover': {background: PINK_BORDER},
            }}
        >
            <EventOutlinedIcon sx={{fontSize: 13}}/>
            #{booking_id}
        </Box>
    );

    if (useCallback) {
        return trigger;
    }

    return (
        <>
            {trigger}
            <Drawer
                anchor="right"
                open={open}
                onClose={handleClose}
                PaperProps={{
                    sx: {
                        width: {xs: '100%', sm: '90%', md: '70%', lg: '60%', xl: '55%'},
                        background: '#F7F8FA',
                    },
                }}
                sx={{zIndex: 1500}}
            >
                <Box sx={{display: 'flex', flexDirection: 'column', height: '100vh'}}>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            px: {sm: 2.5, xs: 1.5},
                            py: 1.5,
                            background: '#fff',
                            borderBottom: `1px solid ${PINK_BORDER}`,
                            position: 'sticky',
                            top: 0,
                            zIndex: 2,
                        }}
                    >
                        <Box sx={{display: 'flex', alignItems: 'center', gap: 1.25}}>
                            <Box
                                sx={{
                                    width: 36,
                                    height: 36,
                                    borderRadius: '10px',
                                    background: PINK_BG,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                            >
                                <EventOutlinedIcon sx={{color: BURGUNDY, fontSize: 20}}/>
                            </Box>
                            <Box>
                                <Typography sx={{fontSize: '15px', fontWeight: 700, color: '#1a1a2e', lineHeight: 1.2}}>
                                    Appointment Details
                                </Typography>
                                <Typography sx={{fontSize: '11px', color: BURGUNDY, mt: '2px', fontWeight: 600}}>
                                    Booking #{booking_id}
                                </Typography>
                            </Box>
                        </Box>
                        <IconButton
                            size="small"
                            onClick={handleClose}
                            sx={{
                                width: 34,
                                height: 34,
                                borderRadius: '10px',
                                border: `1px solid ${PINK_BORDER}`,
                                color: BURGUNDY,
                                '&:hover': {background: PINK_BG},
                            }}
                        >
                            <CloseRoundedIcon sx={{fontSize: 20}}/>
                        </IconButton>
                    </Box>

                    <Box
                        sx={{
                            flex: 1,
                            overflowY: 'auto',
                            overflowX: 'hidden',
                            p: {sm: 2, xs: 1},
                            ...scrollCSS,
                        }}
                    >
                        {loading ? <Waveloading fullSize/> : ''}
                        {!loading && !details ? (
                            <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px'}}>
                                <Typography sx={{color: '#9A9797', fontSize: '14px'}}>
                                    No appointment data found for booking {booking_id}.
                                </Typography>
                            </Box>
                        ) : (
                            <AppointmentDetails appointmentDetails={details || {}}/>
                        )}
                    </Box>
                </Box>
            </Drawer>
        </>
    )
}

export default AppointmentDetailsmodal
